import React from "react";
import ShowroomsTable from "./showrooms-table";
import SearchForm from "../../forms/search-form"
import { Layout } from 'antd';
import useQueryShowrooms from './hooks/use-query-showrooms';
import useMutationStandDelete from './hooks/use-mutation-stand-delete';
import KeyTranslation from './../../service/key-translation';
import { GET_STANDS } from "../../../graphql/query/showrooms-gql";
import { STAND_DELETE } from '../../../graphql/mutation/showroom-gql';

import './showrooms.scss';





const { Sider, Content } = Layout;

const Showrooms = () => {

  const {
    eventId,
    setEeIdColumnFilter,
    setPackageIdColumnFilter,
    loadingQuery,
    dataQuery,
    history,
    setSearchVal,
    routePage,
    pagination,
    handleTableChange,
    rowCount
  } = useQueryShowrooms(GET_STANDS);


  const {
    _setMutationStandDelete,
    loadingStandDelete

  } = useMutationStandDelete(STAND_DELETE, dataQuery);



  return (
    <>
      <Layout className="table-header" style={ { background: "white" } }>
        <Content>
          <h1>
            <KeyTranslation
              keyTranslation="heading.large.showrooms"
              defaultValue="Showrooms" />
          </h1>
        </Content>
        <Sider className="search-holder" style={ { background: "white" } }>
          <SearchForm setSearchVal={ setSearchVal } routePage={ routePage } history={ history } />
        </Sider>
      </Layout>
      <ShowroomsTable
        eventId={ eventId }
        setEeIdColumnFilter={ setEeIdColumnFilter }
        setPackageIdColumnFilter={ setPackageIdColumnFilter }
        pagination={ pagination }
        dataQuery={ dataQuery }
        loading={ loadingQuery }
        handleTableChange={ handleTableChange }
        routePage={ routePage }
        setMutationStandDelete={ _setMutationStandDelete }
        loadingStandDelete={ loadingStandDelete }
        rowCount={ rowCount }
      />
    </>
  );
};

export default Showrooms;
